import React from 'react'
import { parseUrlQuery } from 'utilities'
import { Body } from 'components/Shell/Shell'
import { GET_APP_SETTING_BY_NAME } from 'requests'
import { PaymentError } from "./PaymentCallback"

export default class Error extends React.Component{
  state = {
    error: null,
    errorCode: null,
    errorMessage: null
  }
  componentDidMount = () => {
    const query = parseUrlQuery(this.props.location.search)
    const method = this.props.match.params.method
    this.getErrorByMethod(method, query)
  }
  getErrorByMethod = (method, query) => {
    switch (method) {
      case 'paypal':
      default:
        this.getPaypalError()
        this.setState({errorCode: query.RESULT, errorMessage: query.RESPMSG})
    }
  }
  getPaypalError = () => {
    GET_APP_SETTING_BY_NAME("PAYMENT_ONLINE_ERROR_MESSAGE_POST_paypal", ({VALUE}) => {
      this.setState({error: VALUE})
    })
  }
  render(){
    return(
      <Body className="login-redirector payment-callback">
        {
          this.state.error &&
          <PaymentError errorCode={this.state.errorCode} errorMessage={this.state.errorMessage}>
            {this.state.error}
          </PaymentError>
        }
      </Body>
    )
  }
}
